<div
  [attr.tabindex]="disabled ? null : 0"
  [class.short]="short"
  [class.quick]="quickEvaluationStyle"
  (focus)="onTouched()"
  (blur)="onTouched()"
  (keydown)="onKeyDown($event)"
>
  @if (horizontal !== null && horizontal && !short) {
    <rt-group variant="stacked horizontal" layout-justify-flex-end>
      @for (button of buttons; track trackByButton($index, button)) {
        <rt-button
          [rtTooltip]="'app.interview.summary.' + button.name | translate"
          [rtTooltipPosition]="'above'"
          [class.selected]="isChecked(button.name)"
          (click)="onClick(button.name)"
          variant="tertiary"
          padding-lr
        >
          <rt-icon [name]="button.icon"> </rt-icon>
        </rt-button>
      }
    </rt-group>
  }

  @if (horizontal !== null && !horizontal && !short) {
    <rt-group class="horizontal" variant="horizontal wrap">
      @for (button of buttons; track trackByButton($index, button)) {
        <rt-button
          [class.selected]="isChecked(button.name)"
          (click)="onClick(button.name)"
          variant="tertiary"
          margin-lr-small-xx
        >
          <rt-icon [name]="button.icon" size="medium"> </rt-icon>
          <span>{{ 'app.interview.summary.' + button.name | translate }}</span>
        </rt-button>
      }
    </rt-group>
  }

  @if (short) {
    <rt-group variant="default" layout-horizontal layout-full-width layout-space-between>
      @for (button of buttons; track trackByButton($index, button)) {
        <rt-button
          [rtTooltip]="'app.interview.summary.' + button.name | translate"
          [rtTooltipPosition]="'above'"
          [class.selected]="isChecked(button.name)"
          (click)="onClick(button.name)"
          variant="tertiary"
        >
          <rt-icon [name]="button.icon"> </rt-icon>
        </rt-button>
      }
    </rt-group>
  }
</div>
